import React from "react";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import Container from "@mui/material/Container";
import Typography from "@mui/material/Typography";

import { WEB_URL } from "../../api/URLs";
import { GTM_EVENTS } from "../../constants";
import { GetInspiredCards, MixPanelTrackedLink } from "../../components";

export default function () {
    return <Container className="GetInspiredSection">
        <Stack spacing={6} alignItems="center">
            <Box>
                <Typography variant="h5" align="center" sx={{fontWeight: 600}} color='primary' gutterBottom>Get inspired!</Typography>
                <Typography align="center" gutterBottom>Here’s how our amazing supporters from around the world are raising funds to support education in Pakistan!</Typography>
                {/* <Typography align="center" gutterBottom>You too can choose to do anything to show your support for education.</Typography> */}
                <Typography align="center">The sky is the limit in showing your support for education!</Typography>
            </Box>
            <GetInspiredCards />
            <Stack direction="column" alignItems="center" spacing={2} >
                <Typography variant="h5" align="center" sx={{fontWeight: 600}} color='primary'>How will you fundraise for education?</Typography>
                <MixPanelTrackedLink gtmEvent={GTM_EVENTS.START_FUNDRAISER_CLICKED} className="StartYourFundraiserButton" type="button" href={WEB_URL.CREATE_FUNDRAISER} label="Start Your Fundraiser" context="About us page" variant="contained" sx={{ width: '200px', whiteSpace: 'nowrap' }}>START YOUR FUNDRAISER</MixPanelTrackedLink>

                <MixPanelTrackedLink gtmEvent={GTM_EVENTS.SUPPORT_FUNDRAISER_CLICKED} href={WEB_URL.FUNDRAISER_LISTING} type="link" label="Or find an existing fundraiser" context="About us page">Or find an existing fundraiser</MixPanelTrackedLink>
            </Stack>
        </Stack>
    </Container>
}